import { ISpecialRule } from "./rules";
import { IUpgradeOption, IUpgradeSection } from "./upgrades";

export type WoundPotential = { melee: number; ranged: number };
export type ValidationError = { type: ValidationErrorType; message: string };

// int Flags
export enum BalanceInvalidReasons {
  None = 0,
  Wounds = 1 << 0, // 1
  CustomRules = 1 << 1, // 2
  CalcErrors = 1 << 2, // 4
  Spells = 1 << 3, // 8
  CustomSpells = 1 << 4, // 16
  CustomWeapons = 1 << 5, // 32
  NegativeUpgrades = 1 << 6, // 64
  FreeUpgrades = 1 << 7 // 128
}

export enum ValidationErrorType {
  ratio,
  count,
  unit,
  rules,
  customRule
}

export type ValidationResult = {
  sections: ValidatedSection[];
  errors: ValidationError[];
  valid: boolean;
};

export type ValidatedSection = IUpgradeSection & {
  options: ValidatedOption[];
  maxRatio: number;
  isSpecialist: boolean;
  valid: boolean;
  errors: ValidationError[];
  dependencies: string[];
  meleeDetails: WoundDetails;
  rangedDetails: WoundDetails;
};

export type ValidatedOption = IUpgradeOption & {
  woundPotential: WoundPotential;
  tough: number;
  meleeRatio: number;
  rangedRatio: number;
  deadEnd: boolean;
};

export const noWounds: WoundPotential = { melee: 0, ranged: 0 };
const addWoundPotentials = (a: WoundPotential, b: WoundPotential): WoundPotential => ({
  melee: a.melee + b.melee,
  ranged: a.ranged + b.ranged
});
export const sumWoundPotentials = (x: WoundPotential[]) =>
  x.reduce((total, value) => addWoundPotentials(total, value), noWounds);

export const isZeroWounds = (x: WoundPotential) => x.melee === 0 && x.ranged === 0;

export type WoundLimits = {
  unitRatio: number;
  unit: number;
  specialistCount: number;
  specialistRatio: number;
  specialist: number;
};

export type WoundDetails = {
  option: ValidatedOption;
  affectsCount: number;
  hasPotential: boolean;
  potential: number;
  ratio: number;
};

export type UpgradeNode = {
  unit: BalValUnit; // The current loadout
  sections: string[]; // Sections left to check
  history: string[];
};

export type BalValUnit = {
  size: number;
  models: BalValModel[];
  hero: boolean;
  baseTough: number;
  upgrades: string[];
};

export type BalValModel = {
  loadout: any[];
  hero: boolean;
  specialistRanged: boolean;
  specialistMelee: boolean;
  specialRules: (ISpecialRule & { woundPotential: WoundPotential })[];
  ruleWounds: WoundPotential;
  upgrades: {
    instanceId: string;
    section: { id: string; label: string };
    option: { id: string; label: string };
  }[];
  //upgrades: string[];
};
